/* tslint:disable */
import {
  PaymentEntries,
  Lease,
  InvoicePaymentEntry
} from '../index';

declare var Object: any;
export interface TenantPaymentsInterface {
  "lease_id": number;
  "total_paid": number;
  "arrears": number;
  "payment_description": string;
  "cancelled": boolean;
  "digitax_id"?: string;
  "serial_number"?: string;
  "receipt_number"?: number;
  "trader_invoice_number"?: string;
  "internal_data"?: string;
  "receipt_signature"?: string;
  "tenant_kra_pin"?: string;
  "tenant_full_name"?: string;
  "sale_detail_url"?: string;
  "etims_url"?: string;
  "sale_tax_summary"?: any;
  "sale_date_time"?: Date;
  "etims_queue_status"?: string;
  "credit_summary"?: any;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  paymentEntries?: PaymentEntries[];
  lease?: Lease;
  invoicePaymentEntries?: InvoicePaymentEntry[];
}

export class TenantPayments implements TenantPaymentsInterface {
  "lease_id": number;
  "total_paid": number;
  "arrears": number;
  "payment_description": string;
  "cancelled": boolean;
  "digitax_id": string;
  "serial_number": string;
  "receipt_number": number;
  "trader_invoice_number": string;
  "internal_data": string;
  "receipt_signature": string;
  "tenant_kra_pin": string;
  "tenant_full_name": string;
  "sale_detail_url": string;
  "etims_url": string;
  "sale_tax_summary": any;
  "sale_date_time": Date;
  "etims_queue_status": string;
  "credit_summary": any;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  paymentEntries: PaymentEntries[];
  lease: Lease;
  invoicePaymentEntries: InvoicePaymentEntry[];
  constructor(data?: TenantPaymentsInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `TenantPayments`.
   */
  public static getModelName() {
    return "TenantPayments";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of TenantPayments for dynamic purposes.
  **/
  public static factory(data: TenantPaymentsInterface): TenantPayments{
    return new TenantPayments(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'TenantPayments',
      plural: 'TenantPayments',
      path: 'TenantPayments',
      idName: 'id',
      properties: {
        "lease_id": {
          name: 'lease_id',
          type: 'number'
        },
        "total_paid": {
          name: 'total_paid',
          type: 'number'
        },
        "arrears": {
          name: 'arrears',
          type: 'number',
          default: 0
        },
        "payment_description": {
          name: 'payment_description',
          type: 'string'
        },
        "cancelled": {
          name: 'cancelled',
          type: 'boolean',
          default: false
        },
        "digitax_id": {
          name: 'digitax_id',
          type: 'string'
        },
        "serial_number": {
          name: 'serial_number',
          type: 'string'
        },
        "receipt_number": {
          name: 'receipt_number',
          type: 'number'
        },
        "trader_invoice_number": {
          name: 'trader_invoice_number',
          type: 'string'
        },
        "internal_data": {
          name: 'internal_data',
          type: 'string'
        },
        "receipt_signature": {
          name: 'receipt_signature',
          type: 'string'
        },
        "tenant_kra_pin": {
          name: 'tenant_kra_pin',
          type: 'string'
        },
        "tenant_full_name": {
          name: 'tenant_full_name',
          type: 'string'
        },
        "sale_detail_url": {
          name: 'sale_detail_url',
          type: 'string'
        },
        "etims_url": {
          name: 'etims_url',
          type: 'string'
        },
        "sale_tax_summary": {
          name: 'sale_tax_summary',
          type: 'any'
        },
        "sale_date_time": {
          name: 'sale_date_time',
          type: 'Date'
        },
        "etims_queue_status": {
          name: 'etims_queue_status',
          type: 'string'
        },
        "credit_summary": {
          name: 'credit_summary',
          type: 'any'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        paymentEntries: {
          name: 'paymentEntries',
          type: 'PaymentEntries[]',
          model: 'PaymentEntries',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'tenant_payment_id'
        },
        lease: {
          name: 'lease',
          type: 'Lease',
          model: 'Lease',
          relationType: 'belongsTo',
                  keyFrom: 'lease_id',
          keyTo: 'id'
        },
        invoicePaymentEntries: {
          name: 'invoicePaymentEntries',
          type: 'InvoicePaymentEntry[]',
          model: 'InvoicePaymentEntry',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'tenant_payment_id'
        },
      }
    }
  }
}
